import { iPaginationResponse } from "core/kangarooTypes/iPaginationResponse";
import ApiService from "./api";
import { iUser } from "core/kangarooTypes/iUser";
import { UserFormData } from "validationSchema/UserFormSchema";
import { iCity } from "core/kangarooTypes/iCity";
import { AreaFormData } from "features/Admin/components/Configuration/AreaFormDialog";
import { PackageFormData } from "features/Admin/components/Configuration/PackageFormDialog";
import { iMerchantFee } from "core/kangarooTypes/MerchantFee";
import { MerchantFeeFormData } from "features/Admin/components/Configuration/MerchantFeeManagement";
import { iAnalytic } from "core/kangarooTypes/iAnalytic";

export const getUsers = (
  filter?: {
    search?: string | undefined;
    role?: string | undefined;
    getAll?: number | undefined;
    active?: number | undefined;
  },
  page: number = 1
): Promise<iPaginationResponse<iUser>> => {
  return ApiService.fetchData({
    url: `users`,
    method: "GET",
    params: {
      search: filter?.search,
      role: filter?.role,
      get_all: filter?.getAll,
      page: page,
    },
  });
};
export const addUser = (data: UserFormData): Promise<any> => {
  const dataRequest = {
    first_name: data.first_name,
    last_name: data.last_name,
    email: data.email,
    password: data.password,
    phone_number: data.phone_number,
    role: data.role,
  };

  return ApiService.fetchData({
    url: `users`,
    method: "POST",
    data: dataRequest,
  });
};
export const updateUser = (
  data: UserFormData,
  userId: number
): Promise<any> => {
  const dataRequest = {
    first_name: data.first_name,
    last_name: data.last_name,
    email: data.email,
    password: data.password,
    phone_number: data.phone_number,
    role: data.role,
    active: data.active ? 1 : 0,
  };

  return ApiService.fetchData({
    url: `users/${userId}`,
    method: "PUT",
    data: dataRequest,
  });
};
export const deleteUser = (userId: number): Promise<any> => {
  return ApiService.fetchData({
    url: `users/${userId}`,
    method: "DELETE",
  });
};

export const addCity = (data: iCity): Promise<any> => {
  const dataRequest = {
    name: data.name,
    price: data.price,
  };

  return ApiService.fetchData({
    url: `cites`,
    method: "POST",
    data: dataRequest,
  });
};
export const updateCity = (data: iCity, CityId: number): Promise<any> => {
  const dataRequest = {
    name: data.name,
    price: data.price,
  };

  return ApiService.fetchData({
    url: `cites/${CityId}`,
    method: "PUT",
    data: dataRequest,
  });
};
export const deleteCity = (cityId: number): Promise<any> => {
  return ApiService.fetchData({
    url: `cites/${cityId}`,
    method: "DELETE",
  });
};

export const addArea = (data: AreaFormData): Promise<any> => {
  const dataRequest = {
    name: data.name,
    price: data.price,
    city_id: data.cityId,
  };

  return ApiService.fetchData({
    url: `areas`,
    method: "POST",
    data: dataRequest,
  });
};
export const updateArea = (
  data: AreaFormData,
  areaId: number
): Promise<any> => {
  const dataRequest = {
    name: data.name,
    price: data.price,
    city_id: data.cityId,
  };

  return ApiService.fetchData({
    url: `areas/${areaId}`,
    method: "PUT",
    data: dataRequest,
  });
};
export const deleteArea = (areaId: number): Promise<any> => {
  return ApiService.fetchData({
    url: `areas/${areaId}`,
    method: "DELETE",
  });
};

export const addPackage = (data: PackageFormData): Promise<any> => {
  const dataRequest = {
    name: data.name,
    description: data.description,
    price: data.price,
  };

  return ApiService.fetchData({
    url: `sizes`,
    method: "POST",
    data: dataRequest,
  });
};
export const updatePackage = (
  data: PackageFormData,
  packageId: number
): Promise<any> => {
  const dataRequest = {
    name: data.name,
    description: data.description,
    price: data.price,
    active: 1,
  };

  return ApiService.fetchData({
    url: `sizes/${packageId}`,
    method: "PUT",
    data: dataRequest,
  });
};
export const deletePackage = (packageId: number): Promise<any> => {
  return ApiService.fetchData({
    url: `sizes/${packageId}`,
    method: "DELETE",
  });
};

export const getMerchantFees = (): Promise<
  iPaginationResponse<iMerchantFee>
> => {
  return ApiService.fetchData({
    url: `discounts?get_all=1`,
    method: "GET",
  });
};
export const addMerchantFees = (data: MerchantFeeFormData): Promise<any> => {
  const dataRequest = {
    merchant_id: data.merchantId,
    value: data.value,
  };

  return ApiService.fetchData({
    url: `discounts`,
    method: "POST",
    data: dataRequest,
  });
};
export const updateMerchantFees = (
  data: MerchantFeeFormData,
  id: number
): Promise<any> => {
  const dataRequest = {
    merchant_id: data.merchantId,
    value: data.value,
  };

  return ApiService.fetchData({
    url: `discounts/${id}`,
    method: "PUT",
    data: dataRequest,
  });
};

export const deleteMerchantFee = (id: number): Promise<any> => {
  return ApiService.fetchData({
    url: `discounts/${id}`,
    method: "DELETE",
  });
};

// Pick & Pack Fees
export const getPickPackFees = (): Promise<any> => {
  return ApiService.fetchData({
    url: `pick-pack-fees`,
    method: "GET",
  });
};

export const addPickPackFee = (data: any): Promise<any> => {
  return ApiService.fetchData({
    url: `pick-pack-fees`,
    method: "POST",
    data: data,
  });
};

export const updatePickPackFee = (data: any, id: number): Promise<any> => {
  return ApiService.fetchData({
    url: `pick-pack-fees/${id}`,
    method: "PUT",
    data: data,
  });
};

export const deletePickPackFee = (id: number): Promise<any> => {
  return ApiService.fetchData({
    url: `pick-pack-fees/${id}`,
    method: "DELETE",
  });
};

// Additional Services
export const getAdditionalServices = (): Promise<any> => {
  return ApiService.fetchData({
    url: `additional-services`,
    method: "GET",
  });
};

export const addAdditionalService = (data: any): Promise<any> => {
  return ApiService.fetchData({
    url: `additional-services`,
    method: "POST",
    data: data,
  });
};

export const updateAdditionalService = (
  data: any,
  id: number
): Promise<any> => {
  return ApiService.fetchData({
    url: `additional-services/${id}`,
    method: "PUT",
    data: data,
  });
};

export const deleteAdditionalService = (id: number): Promise<any> => {
  return ApiService.fetchData({
    url: `additional-services/${id}`,
    method: "DELETE",
  });
};

export const getAdminAnalytics = (
  from: string,
  to: string
): Promise<iAnalytic> => {
  return ApiService.fetchData({
    url: `dashboard`,
    method: "GET",
    params: {
      from: from,
      to: to,
    },
  });
};

// Cities and Areas
export const getCities = (): Promise<{
  data: { id: number; name: string; price: number }[];
}> => {
  return ApiService.fetchData({
    url: `cites`,
    method: "GET",
  });
};

export const getCityAreas = (
  cityId: string
): Promise<{
  data: { id: number; name: string; price: number }[];
}> => {
  return ApiService.fetchData({
    url: `areas`,
    method: "GET",
    params: {
      city_id: cityId,
      get_all: 1,
    },
  });
};
